(() => {
  const instances = new Map();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');

  function init(slider) {
    if (instances.has(slider) || !window.gsap) return;
    const track = slider.querySelector('.featured-collection__track');
    const group = slider.querySelector('.featured-collection__group');
    if (!track || !group) return;
    const events = new AbortController();
    const on = (type, fn) => slider.addEventListener(type, fn, { signal: events.signal });
    let animation;
    let context;
    const pauseIfNeeded = () => {
      animation?.paused(slider.matches(':hover') || slider.contains(document.activeElement));
    };
    function rebuild() {
      context?.revert();
      animation = null;
      track.querySelectorAll('[data-carousel-copy]').forEach(copy => copy.remove());
      const distance = group.getBoundingClientRect().width;
      if (!distance) return;
      // Keep a full viewport of cards beyond the end of one loop.
      const required = Math.ceil(slider.clientWidth / distance) + 1;
      const existing = track.querySelectorAll('.featured-collection__group').length;
      for (let i = existing; i < required; i++) {
        const copy = group.cloneNode(true);
        copy.dataset.carouselCopy = '';
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('a, button, input, [tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
        track.append(copy);
      }
      if (motion.matches || document.documentElement.dataset.animations === 'false') return;
      context = gsap.context(() => {
        animation = gsap.to(track, {
          x: -distance,
          duration: 25,
          ease: 'none',
          repeat: -1,
        });
      }, slider);
      pauseIfNeeded();
    }
    on('mouseenter', pauseIfNeeded);
    on('mouseleave', pauseIfNeeded);
    on('focusin', pauseIfNeeded);
    on('focusout', event => {
      if (!slider.contains(event.relatedTarget)) animation?.paused(slider.matches(':hover'));
    });
    motion.addEventListener('change', rebuild, { signal: events.signal });
    const resize = new ResizeObserver(rebuild);
    resize.observe(group);
    resize.observe(slider);
    rebuild();
    instances.set(slider, () => { resize.disconnect(); events.abort(); context?.revert(); track.querySelectorAll('[data-carousel-copy]').forEach(copy => copy.remove()); instances.delete(slider); });
  }
  const scan = () => document.querySelectorAll('.featured-collection__slider').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', scan, { once: true });
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    for (const [slider, cleanup] of instances) if (event.target.contains(slider)) cleanup();
  });
})();
